import { Divider, Grid } from '@mui/material'
import { Button } from 'global/components/Button'
import { hasPermission } from 'hooks/useBackendMenu'

export function Seguranca() {
    return hasPermission(['update', 'Funcionários'], () => (
        <section id="seguranca">
            <Divider sx={{ marginBottom: 2, marginTop: 3 }} textAlign="center">
                Segurança
            </Divider>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <span className="text-sm block text-center">
                        A senha padrão atribuída ao funcionário é o seu CPF.
                        Caso necessário, é possível modificá-la. <br />O
                        funcionário também possui a opção de alterar a própria
                        senha por meio do seu perfil.
                    </span>
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                    <Button href="alterar-senha" color="warning">
                        Alterar senha do funcionário
                    </Button>
                </Grid>
            </Grid>
        </section>
    ))
}
